<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="[size, color]"
    viewBox="0 0 20 20"
  >
    <defs>
      <clipPath id="A">
        <path fill="#d9835e" d="M0 0h18.466v14.247H0z" />
      </clipPath>
    </defs>
    <g clip-path="url(#A)">
      <path
        d="M17.148 0a1.32 1.32 0 0 0-.981.438l-9.5 10.575L2.249 6.61a1.32 1.32 0 0 0-1.865.004A1.32 1.32 0 0 0 .388 8.48l5.406 5.383a1.31 1.31 0 0 0 .931.384h.036c.361-.011.703-.168.945-.437L18.13 2.2a1.32 1.32 0 0 0-.982-2.2"
        fill="#d9835e"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "CheckIcon",
  props: {
    size: {
      type: String,
      default: "medium",
      validator: function (value) {
        // The value must match one of these strings
        return ["small", "medium", "large"].includes(value);
      },
    },
    color: {
      type: String,
      default: "grey",
      validator: function (value) {
        // The value must match one of these strings
        return ["grey", "primary", "secondary"].includes(value);
      },
    },
  },
};
</script>

<style scoped>
.medium {
  width: 24px;
  height: 24px;
}
.small {
  width: 20px;
  height: 20px;
}
.grey path {
  fill: #4a4a4a;
}

.primary path {
  fill: #619bc4;
}
.secondary path {
  fill: #d9835e;
}
</style>
